import React from 'react';
import Icon from '../../ui/icon/icon';
import { classnames } from '../../../../utils/classnames';
import formattedAmount from '../../../resale/seller/components/utils';
import { useTranslation } from 'react-i18next';
import './attendeeCard.css';

function FullName({firstName, lastName}) {
    return (
        <div className='neo-attendee-rate-full-name'>
            <span className='neo-attendee-rate-first-name'>{firstName}</span> 
            <span className='neo-attendee-rate-last-name'>{lastName}</span>
        </div>
    )
}

export default function AttendeeCard({
    className = '',
    attendee = {},
    showMore = [],
    index = "",
    formAttendee = {},
    toggleShowMore = () => {},
    isForm = false,
    formErrors = {},
    children,
    disabled = false
}) {
    const { t } = useTranslation();
    const firstName = isForm ? formAttendee['ws-3'] : attendee.header.first_name;
    const lastName = isForm ? formAttendee['ws-2'] : attendee.header.last_name;

    const isError = React.useMemo(() => {
        return Boolean(Object.keys(formErrors).length);
    },[formErrors]);

    return (
        <>
            <p tabIndex={-1} className='neo-div-aria-live' id={`attendee_card_${index}_description`}>{t(`widget.ticketForm.${showMore[index] ? 'expandOpen' : 'expandClose' }`)}</p>
            <h3 className='neo-attendee-rate-card-header'>
                <button 
                    type='button' 
                    id={`attendee_card_${index}`}
                    aria-expanded={String(showMore[index])}
                    aria-describedby={`attendee_card_${index}_description attendee_card_${index}_error`}
                    aria-controls={`attendee_card_${index}_section`}
                    aria-label={t('widget.ticketForm.rate', {rate: attendee.header.rate_name})} 
                    className={classnames('neo-attendee-rate-card__trigger', className, {'show-more': showMore[index], 'disabled': disabled})} 
                    onClick={disabled ? undefined : toggleShowMore}
                >
                    <div className='neo-attendee-rate-card__trigger-content'>
                        <div className='neo-attendee-rate-content'>
                            <div className='neo-attendee-rate-left'>
                                <Icon name='userCircle' size='large' className='neo-attendee-rate-left-icon'/>
                                <div>
                                    {attendee.header.group_name && <div className='neo-attendee-rate-group-title'>{attendee.header.group_name}</div>}
                                    <div className='neo-attendee-rate-title'>{attendee.header.rate_name}</div>
                                </div>
                            </div>
                            <div className='neo-attendee-rate-right'>
                                <div className='neo-attendee-rate-infos-desktop'>
                                    <FullName firstName={firstName} lastName={lastName}/>
                                    {attendee.header.price > 0 && <div className='neo-attendee-rate-price'>{formattedAmount(attendee.header.price, attendee.header.currency)}</div>}
                                </div>
                                {!disabled && <span className='neo-attendee-rate-icon-container'>
                                    <Icon name='arrow' size='small' className={`neo-attendee-rate-icon ${showMore[index] ? 'neo-attendee-rate-icon-down' : 'neo-attendee-rate-icon-up'}`} />
                                </span>}
                            </div>
                        </div>
                        <div className='neo-attendee-rate-infos-mobile'>
                            <FullName firstName={firstName} lastName={lastName}/>
                            {attendee.header.price > 0 && <div className='neo-attendee-rate-price'>{formattedAmount(attendee.header.price, attendee.header.currency)}</div>}
                        </div>
                        {isError && <p id={`attendee_card_${index}_error`} className='neo-attendee-rate-error-message'>{t('widget.ticketForm.invalid-attendee')}</p>}
                    </div>
                </button>
            </h3>
            <div 
                role='region'
                id={`attendee_card_${index}_section`}
                aria-labelledby={`attendee_card_${index}`}
                aria-details={null}
                className={classnames('neo-attendee-rate-children', {'display-block': showMore[index]})}
            >
                {children}
            </div>
        </>
    )
}
